export enum DocumentName {
    TB = 'TB',
    COVIDTestResult = 'COVID Test Result',
}
